import {
  GET_TRANSACTION_PROVISION_LIST,
  GET_TRANSACTION_PROVISION_SEARCH,
  GET_TRANSACTION_PROVISION_LIST_SUCCESS,
  TRANSACTION_PROVISION_API_ERROR,
  GET_TRANSACTION_PROVISION_SEARCH_SUCCESS,
  GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS_SUCCESS,
  GET_TRANSACTION_PROVISION_LINKED_AMOUNTS_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
  recordList: [],
  recordListAmount:[],
  error: {},
  loading: false,
}

const transactionProvision = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TRANSACTION_PROVISION_LIST:
    case GET_TRANSACTION_PROVISION_SEARCH:
      return {
        loading: true
      }
    case GET_TRANSACTION_PROVISION_LIST_SUCCESS:
    case GET_TRANSACTION_PROVISION_SEARCH_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
        loading: false
      }
    case GET_TRANSACTION_PROVISION_LINKED_AMOUNTS_SUCCESS:
      return {
        ...state,
        recordListAmount: action.payload,
      }
      case GET_TRANSACTION_PROVISION_SETTLE_LINKED_AMOUNTS_SUCCESS:
            return {
                ...state,
                recordListAmount: action.payload,
            }
    case TRANSACTION_PROVISION_API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    default:

      return state

  }
}

export default transactionProvision